// jQuery
var $ = require('./vendor/jquery.min.js');
global.jQuery = $;

require('./vendor/what-input.min.js');
require('./vendor/foundation');


$(document).foundation();

  // logo fade in footer
  var divs = $('.partner-logo');

  function fade() {
      var current = $('.current');
      var currentIndex = divs.index(current),
          nextIndex = currentIndex + 1;

      if (nextIndex >= divs.length) {
          nextIndex = 0;
      }

      var next = divs.eq(nextIndex);

      next.stop().fadeIn(2000, function() {
          $(this).addClass('current');
      });

      current.stop().fadeOut(2000, function() {
          $(this).removeClass('current');
          setTimeout(fade, 2500);
      });
  }

  fade();


$(window).on('load resize', function() {
        // Create breakpoint body.class
        // https://github.com/zurb/foundation/issues/5139
        console.log(Foundation.MediaQuery.current);
    })



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/app.js
 ** module id = 0
 ** module chunks = 0
 **/